import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';
import useAppStore from 'store/useAppStore';
import { produce } from 'immer';
import IndexField from './IndexField';
import { useShallow } from 'zustand/react/shallow';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import SortableTableRow from './SortableTableRow';

const EditDeviceList = () => {
  const readOnly = useAppStore((state) => state.selectedProject.readOnly);
  const materialDevicekeys = useAppStore((state) => state.materialDeviceKeys);
  const materialDevicesIds = useAppStore(
    useShallow((state) => state.materialDevices.map(({ id }) => id)),
  );
  const setter = useAppStore((state) => state.setter);
  const reorderMaterialDevices = useAppStore(
    (state) => state.reorderMaterialDevices,
  );
  const setMaterialDevices = (value) => {
    setter('materialDevices', value);
  };
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = materialDevicesIds.findIndex((id) => id === active.id);
      const newIndex = materialDevicesIds.findIndex((id) => id === over.id);
      reorderMaterialDevices(oldIndex, newIndex);
    }
  };
  const getNewItem = () => {
    const initItem = {
      id: uuidv4(),
    };
    materialDevicekeys.forEach((key) => {
      initItem[key] = '';
    });
    return initItem;
  };
  const addDeviceToPosition = (position) => {
    setMaterialDevices(
      produce((draft) => {
        draft.splice(position, 0, getNewItem());
      }),
    );
  };
  const addDeviceToEnd = () => {
    setMaterialDevices(
      produce((draft) => {
        draft.push(getNewItem());
      }),
    );
  };

  return (
    <>
      <div className="flex justify-between">
        <Typography variant="h6">物料設備移動列表</Typography>
        {readOnly === false && (
          <div className="flex gap-2 flex-wrap justify-end">
            <Button
              color="success"
              variant="contained"
              onClick={addDeviceToEnd}
            >
              新增設備
            </Button>
          </div>
        )}
      </div>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
      >
        <Table>
          <TableHead>
            <TableRow>
              {materialDevicekeys.map((value) => (
                <TableCell key={value}>{value}</TableCell>
              ))}
              {readOnly === false && (
                <>
                  <TableCell>新增</TableCell>
                  <TableCell>刪除</TableCell>
                  <TableCell sx={{ minWidth: 70 }}>排序</TableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            <SortableContext items={materialDevicesIds}>
              {materialDevicesIds.map((id, index) => {
                return (
                  <SortableTableRow id={id} key={id}>
                    {materialDevicekeys.map((value) => (
                      <TableCell key={value}>
                        <IndexField
                          type="materialDevices"
                          valueKey={value}
                          index={index}
                          placeholder={`輸入${value}`}
                        />
                      </TableCell>
                    ))}
                    {readOnly === false && (
                      <>
                        <TableCell>
                          <IconButton
                            className="self-start"
                            onClick={() => {
                              addDeviceToPosition(index + 1);
                            }}
                          >
                            <Add color="primary" />
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            className="self-start"
                            onClick={() => {
                              setMaterialDevices(
                                produce((draft) => {
                                  draft.splice(index, 1);
                                }),
                              );
                            }}
                          >
                            <Delete color="error" />
                          </IconButton>
                        </TableCell>
                      </>
                    )}
                  </SortableTableRow>
                );
              })}
            </SortableContext>
          </TableBody>
        </Table>
      </DndContext>
    </>
  );
};
export default EditDeviceList;
